import { capitalizeFirstLetter } from '@/helpers/string';
import i18n from '@/i18n';
import { useConfigurationStore } from '@/store/configurationStore';

interface JobLike {
	jobId: string;
	jobName?: string | null;
}

export const resolveJobDisplayName = (job: JobLike): string => {
	const configurationStore = useConfigurationStore();

	const fromApi =
		job.jobName && job.jobId !== job.jobName ? job.jobName.trim() : '';
	const fromConfig = configurationStore.getJob(String(job.jobId))?.name?.trim();
	const raw = fromApi || fromConfig || undefined;
	return raw ? capitalizeFirstLetter(raw) : i18n.global.t('global.job.unknown');
};
